var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1834 15.6917L12.59 12.0278C13.4949 10.859 14.0404 9.38755 14.0404 7.78689C14.0404 4.0036 11.0217 0.925781 7.3112 0.925781C3.60066 0.925781 0.582031 4.0036 0.582031 7.78689C0.582031 11.5702 3.60066 14.648 7.3112 14.648C8.88186 14.648 10.3243 14.0926 11.4706 13.1692L15.064 16.8331C15.2184 16.9905 15.421 17.0696 15.6237 17.0696C15.8264 17.0696 16.029 16.9905 16.1834 16.8331C16.4929 16.5175 16.4929 16.0073 16.1834 15.6917ZM2.16536 7.78689C2.16536 4.89393 4.47386 2.54016 7.3112 2.54016C10.1485 2.54016 12.457 4.89393 12.457 7.78689C12.457 10.6799 10.1485 13.0336 7.3112 13.0336C4.47386 13.0336 2.16536 10.6799 2.16536 7.78689Z",
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.fa9249843861bf39b13dcb4ecef7b1a9.svg";
export { ForwardRef as ReactComponent };